/**
 * This module contains code for State Parameters.
 *
 * See [[ParamDeclaration]]
 *
 * @packageDocumentation @preferred
 */
export * from './interface';
export * from './param';
export * from './paramTypes';
export * from './stateParams';
export * from './paramType';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/params/index.js
// module id = 108
// module chunks = 0